// AUTH
export const SIGNIN_ROUTE = '/logar';
export const SIGNUP_ROUTE = '/signup';
export const FORGET_PASSWORD_ROUTE = '/esqueci-minha-senha';

//PATIENTS
export const PATIENTS_ROUTE = '/pacientes';
export const PATIENT_VIEW_ROUTE = '/pacientes/:id/visualizar';
export const PATIENT_REGISTER_ROUTE = '/pacientes/cadastro';
export const PATIENT_EDIT_ROUTE = '/pacientes/:id/editar';
export const PATIENT_RESET_PASSWORD = '/pacientes/resetar-senha/:token';
export const PATIENT_REMOVE_ROUTE = '/paciente/:id/programa/:id/remove';

// USERS
export const USERS_ROUTE = '/usuarios';
export const USER_REGISTER_ROUTE = '/usuarios/cadastro';
export const USER_EDIT_ROUTE = '/usuarios/:id/editar';
export const PASSWORD_CHANGE_ROUTE = '/usuarios/:id/trocar-senha';
export const USER_RESET_PASSWORD = '/usuarios/resetar-senha/:token';

//ACCREDITED
export const ACCREDITEDS_ROUTE = '/credenciados';
export const ACCREDITED_VIEW_ROUTE = '/credenciados/:id/visualizar';
export const ACCREDITED_REGISTER_ROUTE = '/credenciados/cadastro';
export const ACCREDITED_EDIT_ROUTE = '/credenciados/:id/editar';
export const ACCREDITED_REMOVE_ROUTE = '/credenciados/:id';

//FORMS
export const FORMS_ROUTE = '/formularios';
export const FORMS_VIEW_ROUTE = '/formularios/:id/visualizar';
export const FORMS_REGISTER_ROUTE = '/formularios/cadastro';
export const FORMS_EDIT_ROUTE = '/formularios/:id/editar';
export const FORMS_REMOVE_ROUTE = '/formularios/:id';

//FORMS TEVA
export const FORMS_TEVA_ROUTE = '/formulario-teva/:idfollowup';

//INTEGRATION
export const ROOT_URL = process.env.ROOT_URL ? process.env.ROOT_URL : 'http://localhost:3001';